import { animate, createTimer, createTimeline, scrambleText, $ } from 'https://esm.sh/animejs';

/*

const scrambleParams = {
  text: Str(),
  from: Select(['auto', 'left', 'right', 'center', 'random']),
  reversed: Bool(false),
  ease: Select(['linear', 'in(2)', 'out(2)', 'inOut(2)', 'steps(10)']),
  chars: Select(['', 'lowercase', 'uppercase', 'numbers', 'symbols', 'braille', 'blocks', 'shades'], 0),
  cursor: Str('░▒▓█'),
  override: Override(false),
  perturbation: Float(0, 0, 1, 0.01),
  duration: Int(500),
  delay: Int(0, 0, 2000),
  revealDelay: Int(0, 0, 2000),
  revealRate: Int(50),
  settleDuration: Int(250),
  settleRate: Int(30),
}; */

const scrambleParams = {
  override: false,
  duration: 750,
  settleDuration: 250,
  perturbation: .2,
  cursor: '░▒▓█',
}

const intro = createTimeline({ delay: 500 });

$('.scramble').forEach($el => {
  const replay = () => animate($el, { innerHTML: scrambleText({ ...scrambleParams, text: scrambleParams.text || undefined }) });
  intro.add($el, {
    innerHTML: scrambleText({
      override: '',
      duration: 750,
      settleDuration: 250,
      perturbation: .2,
      cursor: '░▒▓█',
    }),
  }, '-=620');
  $el.addEventListener('pointerenter', replay);
  $el.addEventListener('pointerdown', replay);
});

intro.init();
